import { Component } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/common';

@Component({
  selector: 'yard-transport-visualization-administration-widget',
  standalone: false,
  templateUrl: './transport-visualization-administration-widget.component.html',
  styleUrl: './transport-visualization-administration-widget.component.scss',
})
export class TransportVisualizationAdministrationWidgetComponent extends AbstractWidgetComponent {

}
